import useDocumentTitle from "hooks/useDocumentTitle";
import { useForm, FormProvider } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

import { BundledCptCodes } from "./components/BundledCptCodes";
import { ContractLanguageField } from "./components/ContractLanguageField";
import { Header } from "./components/Header";
import { ProviderAndPayerSection } from "./components/ProviderAndPayerSection";
import { RuleName } from "./components/RuleName";
import { SubmitPackages } from "./components/SubmitPackages";
import { TriggerCptCodes } from "./components/TriggerCptCodes";

export function CreatePackagesPage() {
  useDocumentTitle("Create Package Rules");
  const [searchParams] = useSearchParams();
  const asDefault = searchParams.get("asDefault") === "true";

  const methods = useForm({
    defaultValues: {
      provider: [],
      payerName: "",
      groupName: "",
      triggerCptCodes: [],
      bundledCptCodes: [],
      isDefault: asDefault,
      contractLanguage: "",
    },
  });
  return (
    <FormProvider {...methods}>
      <Header isPackages />
      <ProviderAndPayerSection />
      <RuleName />
      <TriggerCptCodes />
      <BundledCptCodes />
      <ContractLanguageField ruleType="PACKAGE" />
      <SubmitPackages />
    </FormProvider>
  );
}
